import React from 'react';

/*
    - ihoDesignSystem
*/
import { Container, Grid } from '@iho-design-system/Loader';

/*
    - pages
*/
import HelpDesk from './HelpDesk';

/*
    - myComponents
*/
import Banner from '../components/Banner';
import HelpBadge from '../components/HelpBadge';
import LeftBar from '../components/LeftBar';
import OnlineSupport from '../components/OnlineSupport';
import RightBar from '../components/RightBar';

/*
    - api
*/
import platformQuestionsAPI from '../api/get/PlatformQuestions';
import platformSubjectsAPI from '../api/get/PlatformSubjects';

const Landing = () => {

    /*
        - defaultData
    */
    const [helpDeskStatus, setHelpDeskStatus] = React.useState(false);
    const [manualChangeTab, setManualChangeTab] = React.useState('');
    const [scrollQuestion, setScrollQuestion] = React.useState('');
    const [selectedQuestion, setSelectedQuestion] = React.useState('');
    const [searchParameter, setSearchParameter] = React.useState('');

    const [platformQuestionsResult, setPlatformQuestionsResult] = React.useState([]);
    const [platformSubjectsResult, setPlatformSubjects] = React.useState([]);

    /*
        - fetchData
    */
    React.useEffect(() => {
        const urlSearchParameter = new URLSearchParams(document.location.search);
        const fetchData = async () => {
            let platformSubjectsResult = await platformSubjectsAPI();
            if (platformSubjectsResult !== 'empty') {
                setPlatformSubjects(platformSubjectsResult);
            }
            let platformquestionsResult = await platformQuestionsAPI();
            if (platformquestionsResult !== 'empty') {
                setPlatformQuestionsResult(platformquestionsResult);
            }
            setSearchParameter(urlSearchParameter.get('id'));
        }
        fetchData();
    }, []);

    /*
        - toggleHelpDesk
    */
    const toggleHelpDeskProps = () => {
        setHelpDeskStatus(!helpDeskStatus);
        setManualChangeTab('home');
    }

    /*
        - toggleTabData
    */
    const toggleTabprops = (tabType) => {
        toggleHelpDeskProps();
        setManualChangeTab(tabType);
    }

    /*
        - scrollQuestionProps
    */
    const scrollQuestionProps = (props) => {
        setSelectedQuestion('');
        setScrollQuestion(props);
    }

    /*
        - selectedQuestionProps
    */
    const selectedQuestionProps = (selectedQuestionProps) => {
        setScrollQuestion('');
        setSelectedQuestion(selectedQuestionProps)
    }

    /*
        - componentData
    */
    let rightBarData = [];
    rightBarData.platformSubjects = platformSubjectsResult;

    let leftBarData = [];
    leftBarData.platformQuestions = platformQuestionsResult;
    leftBarData.scrollQuestion = scrollQuestion;
    leftBarData.selectedQuestion = selectedQuestion;
    leftBarData.searchParameter = searchParameter;

    let bannerData = [];
    bannerData.platformQuestions = platformQuestionsResult;

    return (

        <React.Fragment>

            <Banner
                props={bannerData}
                selectedQuestionProps={selectedQuestionProps} />

            {!helpDeskStatus &&
                <HelpBadge
                    toggleHelpDeskProps={toggleHelpDeskProps} />
            }
            <Container
                size='md'>
                {helpDeskStatus &&
                    <HelpDesk
                        toggleHelpDeskProps={toggleHelpDeskProps}
                        manualChangeTab={manualChangeTab} />
                }
                <Grid>
                    <Grid.Wrapper>
                        <Grid.Item
                            size='col-12'>
                            <OnlineSupport
                                toggleHelpDeskProps={toggleHelpDeskProps} />
                        </Grid.Item>
                        <Grid.Item
                            size='col-12 sm-3'>
                            <RightBar
                                props={rightBarData}
                                scrollQuestionProps={scrollQuestionProps} />
                        </Grid.Item>
                        <Grid.Item
                            size='col-12 sm-9'>
                            <LeftBar
                                props={leftBarData}
                                toggleTabprops={toggleTabprops} />
                        </Grid.Item>
                    </Grid.Wrapper>
                </Grid>
            </Container>

        </React.Fragment>

    );

}

export default Landing;